import type { InputProps } from '../input';

import { forwardRef, useState } from 'react';

import { EyeIcon } from '@paid-ui/icons/eye';
import { EyeOffIcon } from '@paid-ui/icons/eye-off';

import { Input } from '../input';
import { UnstyledButton } from '../unstyled-button';

export interface PasswordInputProps
  extends Omit<InputProps, 'type' | 'autoComplete' | 'autoCapitalize' | 'autoCorrect' | 'suffix'> {
  autoComplete?: 'off' | 'current-password' | 'new-password';
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ size, autoComplete = 'off', disabled, ...restProps }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setShowPassword(true);
    };

    const handleMouseUpOrLeave = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setTimeout(() => setShowPassword(false), 500);
    };

    return (
      <Input
        ref={ref}
        size={size}
        disabled={disabled}
        autoComplete={autoComplete}
        {...restProps}
        type={showPassword ? 'text' : 'password'}
        autoCapitalize="none"
        autoCorrect="off"
        suffix={
          <UnstyledButton
            tabIndex={-1}
            disabled={disabled}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUpOrLeave}
            onMouseLeave={handleMouseUpOrLeave}
          >
            {showPassword ? (
              <EyeIcon className="h-[1em] w-[1em] text-blue" />
            ) : (
              <EyeOffIcon className="h-[1em] w-[1em]" />
            )}
          </UnstyledButton>
        }
      />
    );
  },
);

PasswordInput.displayName = 'PasswordInput';
